<section>
  <div class="container">
    <div class="section-heading text-center">
      <h2>Todos nuestos planes incluyen</h2>
      <p class="lead text-secondary">
        Obtenga acceso a un montón de funciones listas para usar
      </p>
    </div>

    <div class="row gap-y text-center text-md-left">
      <div
        class="col-md-4 shadow-hover"
        *ngFor="let feature of features; let i = index"
      >
        <dc-feather
          [name]="feature.icon"
          [iconClass]="'stroke-info'"
          class="mr-2 m-0"
          *ngIf="i == 0 || i == 2 || i == 5"
        ></dc-feather>
        <div *ngIf="i == 1">
          <img
            src="../../../assets/img/logos-grupo/modulos.png"
            style="width: 40px;"
          />
        </div>
        <div *ngIf="i == 3">
          <img
            src="../../../assets/img/logos-grupo/triangulo.png"
            style="width: 40px;"
          />
        </div>
        <div *ngIf="i == 4">
          <img
            src="../../../assets/img/logos-grupo/headphones.png"
            style="width: 40px;"
          />
        </div>
        <h5 class="bold my-3">{{ feature.title }}</h5>
        <p class="my-0">
          {{ feature.mensaje }}
        </p>
      </div>
    </div>
  </div>
</section>
